import React, { useRef } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartOptions,
  ChartData,
} from 'chart.js'
import { Bar, getElementAtEvent } from 'react-chartjs-2'
import { brandColors, chartSettings } from '../common/const'

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

interface CountSOCChartProps {
  labels: string[]
  dataSets: {
    soc45_0: number[]
    soc60_45: number[]
    soc80_60: number[]
    soc100_80: number[]
  }
  chartTitle: string
  dataLabel: string
  onClick?: (index: number) => void
}

export const CountSOCChart: React.FC<CountSOCChartProps> = ({
  labels, dataSets, chartTitle, dataLabel, onClick
}) => {
  const chartRef = useRef()
  const data: ChartData<'bar'> = {
    labels,
    datasets: [
      {
        label: `${dataLabel} 80-100`,
        data: dataSets.soc100_80,
        backgroundColor: brandColors.safe,
        stack: 'soc',
        borderWidth: 0,
        borderRadius: 0,
      },
      {
        label: `${dataLabel} 60-80`,
        data: dataSets.soc80_60,
        backgroundColor: brandColors.normal,
        stack: 'soc',
        borderWidth: 0,
        borderRadius: 0,
      },
      {
        label: `${dataLabel} 45-60`,
        data: dataSets.soc60_45,
        backgroundColor: brandColors.warning,
        stack: 'soc',
        borderWidth: 0,
        borderRadius: 0,
      },
      {
        label: `${dataLabel} 0-45`,
        data: dataSets.soc45_0,
        backgroundColor: brandColors.danger,
        stack: 'soc',
        borderWidth: 0,
        borderRadius: 0,
      }
    ]
  }

  const onBarClick = (event: React.MouseEvent<HTMLCanvasElement>) => {
    if (!chartRef.current || !onClick) {
      return
    }
    const elements = getElementAtEvent(chartRef.current, event)
    if (!elements || elements.length == 0) {
      return
    }
    const element = elements[0]
    const index = element.index
    onClick(index)
  }

  return <Bar ref={chartRef} data={data} options={{
    responsive: true,
    plugins: {
      legend: { position: 'bottom' },
      title: { display: true, text: chartTitle },
    },
    scales: {
      x: { stacked: true },
      y: { stacked: true },
    },
  }} {...chartSettings} onClick={onBarClick}  />
}